import React, { FC, useState } from 'react'
import DisableContextMenu from 'components/DisableContextMenu'
// import TrustPilotWidget from 'components/TrustPilot/Widget'
import VisibilityTrigger from 'components/VisibilityTrigger'
import Breadcrumb from '../components/Breadcrumb'
import RelatedSearches from '../components/RelatedSearches'
import { MainContent } from '../components/styles/layout'
import ArtworkDescriptionSection from '../components/ArtworkDescriptionSection'
import AboutArtist from '../components/AboutArtist'
import USPSection from '../components/USPSection'
import LayoutConnector, { ConnectorProps as LayoutProps } from '../connectors/Layout'
import Admin from './Admin'
import Carousels from './Carousels'
import Products from './Products'
import Gallery from '../components/Gallery'

const PDPLayoutComponent: FC<LayoutProps> = (props) => {
  const { pageIsReady } = props
  const [shouldLoadComponent, setShouldLoadComponent] = useState(false)
  return (
    <>
      {pageIsReady && (
        <DisableContextMenu>
          <Breadcrumb className='link-group-container' />

          <MainContent>
            <Gallery />

            <Products />
          </MainContent>

          <Admin />

          <ArtworkDescriptionSection />

          <VisibilityTrigger setShouldLoadComponent={setShouldLoadComponent} />

          <AboutArtist />

          <Carousels
            shouldLoadComponent={shouldLoadComponent}
            setShouldLoadComponent={setShouldLoadComponent}
          />

          <USPSection />

          {/* <TrustPilotWidget styles={`${'max-width: 1256px;
        margin: 0 auto; padding: 45px 0;'}`} /> */}
          <RelatedSearches />
        </DisableContextMenu>
      )}
    </>
  )
}
export default LayoutConnector(PDPLayoutComponent)
